module.exports = __webpack_public_path__ + "media/images/icon__twitter-e0321e19b19298f3a5463a083b07bc58.png";